<cigna-status-badge
  [type]="statusType"
  [text]="PrecertificationStatus[status]"
  [size]="size"
  [hasIcon]="true"
></cigna-status-badge>
